import TempEntry from 'components_v2/_entryPoints/TempEntry'
import React, { Suspense } from 'react'

const SignUpNew = React.lazy(() =>
  import('components_v2/Subscribe/Signup/Aloaccess/SignUpNew')
)

export const SignUpNewTempEntry = ({ ...rest }) => {
  localStorage.setItem('iosHeaders', JSON.stringify(rest))

  return (
    <TempEntry
      mt='0px'
      pb='60px'
      controls={{
        footerFlush: {
          mobile: true,
          desktop: true
        }
      }}
      {...rest}
    >
      <Suspense fallback=''>
        <SignUpNew {...rest} />
      </Suspense>
    </TempEntry>
  )
}

export default SignUpNewTempEntry
